import { getHomeLoanTotalLoanAmount } from '__core/shared/util/salestrekker';

import template from './reviewLoanProducts.template.html';
import templateProductSplit from '../lender/productsSplitSearch.template.html';

export default {
  template,
  bindings: {
    formName: '<',
    lenders: '<',
    documents: '<',
    contacts: '<',
    reviewProducts: '<',
    compareProducts: '<',
    fundingWorksheets: '<',
    searchFields: '<',
    maximumBorrowing: '<',
    idTicket: '<',
    idHomeLoan: '<',
    isTicketSettled: '<',
    validationErrors: '<',
    onUpdate: '&',
    onChanged: '&',
    onProductSplitAdded: '&',
    onFinished: '&'
  },
  controller: class controller {
    constructor(
      $q,
      $rootScope,
      $timeout,
      $mdUtil,
      $mdMedia,
      $mdDialog,
      uiService,
      eventService,
      helperService,
      financeService,
      financesService,
      homeLoanService,
      ReviewProduct,
      CompareProduct,
      HomeLoanSearchProduct
    ) {
      'ngInject';

      const ctrl = this;
      ctrl.mdMedia = $mdMedia;
      ctrl.currentOrganization = $rootScope.CurrentOrganization;
      ctrl.currentDateFormat = $rootScope.CurrentDateFormatPrimary();
      ctrl.currentCurrency = $rootScope.CurrentCurrency();
      ctrl.organizationCountry = '';
      ctrl.availableTermYearsOrMonths = [];
      ctrl.availableTermInYears = [];
      ctrl.availableAbsLendingPurposeCodes = [];
      ctrl.compareProductParams = {};
      ctrl.searchAbsCodesTerm = {};
      ctrl.destroyWatch = null;
      ctrl.isProcessing = false;
      ctrl.isReady = false;

      ctrl.initialize = () => {
        ctrl.organizationCountry = helperService.getOrganizationCountry();
        ctrl.availableTermInYears = helperService.getAvailableTermInYears({ isRegular: true });
        ctrl.availableTermYearsOrMonths =
          ctrl.organizationCountry?.cca2 !== 'NZ'
            ? helperService.getAvailableTermInYears({ isRegular: true })
            : helperService.getAvailableTermInYearsShownInMonths({ isRegular: true });
        ctrl.availableAbsLendingPurposeCodes =
          homeLoanService.getAvailableAbsLendingPurposeCodes();
        ctrl.lenders = ctrl.lenders || [];
        ctrl.documents = ctrl.documents || [];
        ctrl.contacts = ctrl.contacts || [];
        ctrl.reviewProducts = ctrl.reviewProducts || [];
        ctrl.compareProducts = ctrl.compareProducts || [];
        ctrl.fundingWorksheets = ctrl.fundingWorksheets || {};
        ctrl.searchFields = ctrl.searchFields || {};
        ctrl.maximumBorrowing = ctrl.maximumBorrowing || {};
        ctrl.validationErrors = ctrl.validationErrors || [];
        ctrl.idTicket = ctrl.idTicket || '';
        ctrl.idHomeLoan = ctrl.idHomeLoan || '';
        ctrl.isTicketSettled = ctrl.isTicketSettled || false;
        ctrl.isQuickTool = !ctrl.idTicket || false;
        if (ctrl.reviewProducts?.length && ctrl.reviewProducts?.length > 4) {
          const pLen = ctrl.reviewProducts?.length || 0;
          ctrl.reviewProducts = ctrl.reviewProducts.splice(pLen - 4, pLen - 1);
          ctrl.compareProducts = ctrl.compareProducts.splice(pLen - 4, pLen - 1);
          ctrl.saveReviewLoanProducts(
            ctrl.anyProductHaveADifferentLoanAmountThanFWLoanAmount()
          );
        } else if (
          ctrl.reviewProducts?.length &&
          ctrl.reviewProducts?.length <= 4 &&
          !ctrl.isTicketSettled &&
          !ctrl.anyProductHaveADifferentLoanAmountThanFWLoanAmount()
        ) {
          ctrl.isProcessing = true;
          ctrl.homeLoanCompareProductEstimate();
        }
        ctrl.isReady = true;
      };

      ctrl.updateTicketValue = () => {
        const loanAmountWithLmi = getHomeLoanTotalLoanAmount(
          ctrl.reviewProducts,
          ctrl.organizationCountry.cca2
        );
        ctrl.onUpdate({ loanAmountWithLmi });
      };

      ctrl.homeLoanCompareProductEstimate = () => {
        if (ctrl.isQuickTool) {
          ctrl.compareProductParams = {
            fundingWorksheets: ctrl.fundingWorksheets,
            searchFields: ctrl.searchFields,
            reviewProducts: ctrl.reviewProducts,
            compareProducts: ctrl.compareProducts,
            maximumBorrowing: ctrl.maximumBorrowing
          };
          const rLen = ctrl.reviewProducts?.length || 0;
          for (let r = 0; r < rLen; r += 1) {
            const reviewProduct = ctrl.reviewProducts[r];
            const cLen = ctrl.compareProductParams?.maximumBorrowing?.contacts?.length || 0;
            for (let c = 0; c < cLen; c += 1) {
              const contact = ctrl.compareProductParams?.maximumBorrowing?.contacts[c];
              const liabilitiesProposed = financeService.prepareServicingProposedLiabilities({
                contacts: ctrl.compareProductParams?.maximumBorrowing?.contacts || [],
                product: reviewProduct || {},
                searchFields: ctrl.searchFields || {},
                idContact: contact?.id || `applicant${_.add(c, 1)}`
              });
              contact.liabilitiesProposed =
                contact.liabilitiesProposed.concat(liabilitiesProposed);
            }
          }
        }

        financesService
          .homeLoanProductsCompare({
            idTicket: ctrl.idTicket,
            compareProductParams: ctrl.compareProductParams
          })
          .then((res) => {
            if (res?.status) {
              ctrl.reviewProducts = res?.reviewProducts?.length
                ? res?.reviewProducts
                : ctrl.reviewProducts;
              ctrl.compareProducts = res?.compareProducts?.length
                ? res?.compareProducts
                : ctrl.compareProducts;
              const data = {
                reviewProducts: ctrl.reviewProducts,
                compareProducts: ctrl.compareProducts
              };
              ctrl.updateTicketValue();
              ctrl.onChanged({ data });
            }
            ctrl.isProcessing = false;
          });
      };

      ctrl.anyProductHaveADifferentLoanAmountThanFWLoanAmount = () =>
        _.some(ctrl.reviewProducts || [], (r) => !ctrl.isLoanAmountTheSame(r));

      ctrl.totalLoanAmountFW = () =>
        _.reduce(
          ctrl.fundingWorksheets?.fundsAvailable || [],
          (memo, n) => _.add(memo, _.toNumber(n?.proposedLoanAmount || 0)),
          0
        );
      ctrl.totalLoanAmountRP = (selectedProduct) =>
        _.reduce(
          selectedProduct?.productSplits || [],
          (memo, n) => _.add(memo, _.toNumber(n?.totalLoanAmount || 0)),
          0
        );

      ctrl.isLoanAmountTheSame = (selectedProduct) =>
        !ctrl.isQuickTool
          ? ctrl.totalLoanAmountFW() === ctrl.totalLoanAmountRP(selectedProduct)
          : true;

      ctrl.clearSearchTerm = ({ idx }) => {
        ctrl.searchAbsCodesTerm[idx + 1] = '';
      };

      ctrl.absCodesChanges = (absLendingPurposeCode, idReviewProduct, idProductSplit) => {
        if (absLendingPurposeCode?.id && absLendingPurposeCode?.value) {
          const rIdx = _.findIndex(ctrl.reviewProducts || [], (p) => p?.id === idReviewProduct);
          if (rIdx > -1) {
            const pIdx = _.findIndex(
              ctrl.reviewProducts[rIdx]?.productSplits || [],
              (p) => p?.id === idProductSplit
            );
            if (pIdx > -1) {
              ctrl.clearSearchTerm({ idx: pIdx });
              const rLen = ctrl.reviewProducts?.length || 0;
              for (let r = 0; r < rLen; r += 1) {
                if (ctrl.reviewProducts[r]?.productSplits[pIdx]) {
                  ctrl.reviewProducts[r].productSplits[pIdx].absLendingPurposeCode =
                    absLendingPurposeCode;
                }
              }
              const cLen = ctrl.compareProducts?.length || 0;
              for (let c = 0; c < cLen; c += 1) {
                if (ctrl.compareProducts[c]?.productSplits[pIdx]) {
                  ctrl.compareProducts[c].productSplits[pIdx].absLendingPurposeCode =
                    absLendingPurposeCode;
                }
              }
              ctrl.saveReviewLoanProducts(true);
            }
          }
        }
      };

      ctrl.isProductIO = ({ productSplit }) =>
        homeLoanService.isProductIO({ product: productSplit });

      ctrl.productSplitAdd = ({ event, idReviewProduct, idLender }) => {
        event.stopPropagation();
        const lender = ctrl.getLender(idLender);
        if (idReviewProduct && !_.isEmpty(lender)) {
          ctrl.searchFields.idLenders = [lender.id];
          ctrl.saveReviewLoanProducts(true);
          if (!ctrl.isQuickTool) {
            $mdDialog
              .show({
                targetEvent: event,
                locals: {
                  lenders: [lender],
                  documents: ctrl.documents,
                  reviewProducts: ctrl.reviewProducts,
                  compareProducts: ctrl.compareProducts,
                  searchFields: ctrl.searchFields,
                  idTicket: ctrl.idTicket,
                  idHomeLoan: ctrl.idHomeLoan
                },
                template: templateProductSplit,
                controllerAs: '$ctrl',
                controller(
                  lenders,
                  documents,
                  reviewProducts,
                  compareProducts,
                  searchFields,
                  idTicket,
                  idHomeLoan
                ) {
                  const self = this;
                  self.product = {};
                  self.lenders = lenders;
                  self.documents = documents;
                  self.reviewProducts = reviewProducts;
                  self.compareProducts = compareProducts;
                  self.searchFields = searchFields;
                  self.idTicket = idTicket;
                  self.idHomeLoan = idHomeLoan;
                  self.changedData = '';
                  self.saveSearchLoanProducts = (dataToSave) => {
                    const data = {
                      id: self.idHomeLoan,
                      hLCD: dataToSave?.hLCD || ''
                    };
                    if (!_.isEmpty(dataToSave?.searchFields)) {
                      data.searchFields = HomeLoanSearchProduct.Build(dataToSave.searchFields);
                    }
                    if (dataToSave?.reviewProducts) {
                      data.reviewProducts = _.map(
                        _.compact(dataToSave.reviewProducts),
                        (reviewProduct) => ReviewProduct.Build(reviewProduct)
                      );
                    }
                    if (dataToSave?.compareProducts) {
                      data.compareProducts = _.map(
                        _.compact(dataToSave.compareProducts),
                        (compareProduct) => CompareProduct.Build(compareProduct)
                      );
                    }
                    if (data?.id && !_.isEmpty(dataToSave)) {
                      homeLoanService.updateHomeLoanPartial(data).then((result) => {
                        if (result.status) {
                          self.changedData = dataToSave.dataType;
                        }
                        eventService.changedData({ changedData: data?.hLCD || '' });
                      });
                    }
                  };

                  self.productSelected = (data) => {
                    $mdDialog.hide({ idReviewProduct, product: data });
                  };
                  self.cancel = () => {
                    $mdDialog.cancel();
                  };
                }
              })
              .then((result) => {
                ctrl.productSplitAdded(result.idReviewProduct, result.product);
              });
          } else {
            const data = {
              idReviewProduct,
              searchFields: ctrl.searchFields
            };
            ctrl.onProductSplitAdded({ data });
          }
        } else {
          uiService.toast({
            text: {
              p1: 'Selected',
              p2: 'lender or product',
              p3: 'does not exist'
            },
            success: true
          });
        }
      };

      ctrl.productSplitAdded = (idReviewProduct, product) => {
        const rIdx = _.findIndex(ctrl.reviewProducts || [], (p) => p?.id === idReviewProduct);
        if (rIdx > -1 && !_.isEmpty(product)) {
          const [reviewProductSplit, compareProductSplit] = homeLoanService.addProductToSplits({
            selectedProduct: product
          });
          if (!_.isEmpty(reviewProductSplit) && !_.isEmpty(compareProductSplit)) {
            ctrl.reviewProducts[rIdx].productSplits.push(reviewProductSplit);
            ctrl.compareProducts[rIdx].productSplits.push(compareProductSplit);
            let absLendingPurposeCode;
            const sIdx = ctrl.reviewProducts[rIdx]?.productSplits?.length - 1;
            const rLen = ctrl.reviewProducts?.length || 0;
            for (let r = 0; r < rLen; r += 1) {
              if (
                !absLendingPurposeCode &&
                ctrl.reviewProducts[r]?.productSplits[sIdx]?.absLendingPurposeCode?.id
              ) {
                absLendingPurposeCode =
                  ctrl.reviewProducts[r]?.productSplits[sIdx]?.absLendingPurposeCode;
              }
            }
            if (absLendingPurposeCode) {
              ctrl.reviewProducts[rIdx].productSplits[sIdx].absLendingPurposeCode =
                absLendingPurposeCode;
              ctrl.compareProducts[rIdx].productSplits[sIdx].absLendingPurposeCode =
                absLendingPurposeCode;
            }
            ctrl.saveReviewLoanProducts();
          }
        }
      };

      ctrl.reviewProductDelete = (idLender, idReviewProduct) => {
        const idx = _.findIndex(
          ctrl.reviewProducts || [],
          (p) => p?.idLender === idLender && p?.productSplits[0]?.id === idReviewProduct
        );
        if (idx > -1) {
          ctrl.reviewProducts.splice(idx, 1);
          ctrl.compareProducts.splice(idx, 1);
          ctrl.saveReviewLoanProducts(
            ctrl.anyProductHaveADifferentLoanAmountThanFWLoanAmount()
          );
        }
      };

      ctrl.productSplitDelete = ({ idReviewProduct, idProductSplit }) => {
        const rIdx = _.findIndex(ctrl.reviewProducts || [], (p) => p?.id === idReviewProduct);
        if (rIdx > -1) {
          const pIdx = _.findIndex(
            ctrl.reviewProducts[rIdx]?.productSplits || [],
            (p) => p?.id === idProductSplit
          );
          if (pIdx > -1) {
            ctrl.isProcessing = true;
            ctrl.reviewProducts[rIdx].productSplits.splice(pIdx, 1);
            ctrl.compareProducts[rIdx].productSplits.splice(pIdx, 1);
            ctrl.saveReviewLoanProducts(
              ctrl.anyProductHaveADifferentLoanAmountThanFWLoanAmount()
            );
          }
        }
      };

      ctrl.isProductSplitOffset = (productSplit) =>
        productSplit?.selectedProduct?.residential?.offset !== 'NO';

      ctrl.getLender = (idLender) => _.find(ctrl.lenders || [], (l) => l?.id === idLender);

      ctrl.getLenderDocument = (idLender) => {
        const doc = _.find(
          ctrl.documents || [],
          (d) => d?.lender[0]?.id === idLender && _.indexOf(d?.type, 'LOGO') > -1
        );
        return doc?.url || '';
      };

      ctrl.getLimit = (productSplit) => {
        if (productSplit?.selectedProduct?.residential?.ioMaxPeriod) {
          return _.add(
            ctrl.organizationCountry?.cca2 !== 'NZ'
              ? _.toNumber(productSplit.selectedProduct.residential.ioMaxPeriod)
              : _.multiply(_.toNumber(productSplit.selectedProduct.residential.ioMaxPeriod), 2),
            1
          );
        }
        return 31;
      };

      ctrl.editOwnership = ($event, productSplit) =>
        helperService
          .editOwnershipOfAssetOrLiability({
            event: $event,
            item: productSplit,
            contacts: ctrl.contacts,
            isDisabled: ctrl.isTicketSettled
          })
          .then((result) => {
            if (result) {
              for (let i = 0; i < ctrl.reviewProducts?.length; i += 1) {
                const idx = helperService.findIndexById(
                  ctrl.reviewProducts[i].productSplits,
                  result.id
                );
                if (idx > -1) {
                  ctrl.reviewProducts[i].productSplits[idx].ownership = result.ownership;
                  ctrl.saveReviewLoanProducts(true);
                }
              }
            }
          });

      ctrl.getContact = (idContact) =>
        ctrl.isQuickTool
          ? _.find(ctrl.maxi, (c) => c.id === idContact)
          : _.find(ctrl.contacts, (c) => c.id === idContact);

      ctrl.getContactName = (idContact) =>
        ctrl.isQuickTool
          ? idContact?.capitalizeFirstLetter()
          : ctrl.getContact(idContact)?.getName() || 'N/A';

      ctrl.reviewProductChanges = _.debounce(() => {
        ctrl.saveReviewLoanProducts();
      }, 3000);

      ctrl.hasValidationError = ({ path }) =>
        helperService.hasValidationError({ errors: ctrl.validationErrors, path });

      ctrl.saveReviewLoanProducts = (isSilent) => {
        ctrl.isProcessing = !isSilent;
        const data = {
          reviewProducts: ctrl.reviewProducts,
          compareProducts: ctrl.compareProducts,
          searchFields: ctrl.searchFields,
          hLCD: isSilent ? '' : 'homeLoanCompareProducts'
        };
        ctrl.onFinished({ data });
      };

      ctrl.destroyWatch = eventService.onChangedData((params) => {
        if (params?.changedData === 'homeLoanCompareProducts') {
          ctrl.homeLoanCompareProductEstimate();
        } else {
          ctrl.isProcessing = false;
        }
      });

      ctrl.$onInit = () => {
        ctrl.initialize();
      };

      ctrl.$onDestroy = () => {
        ctrl.destroyWatch();
      };
    }
  }
};
